import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isPosting: false,
  
  result: [],
};

const authPMTProvReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PMT_PROVIDER_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_PMT_PROVIDER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_PMT_PROVIDER_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.POST_PAIN_MGMT_REQUEST:
      return {
        ...state,
        result: [],
        isPosting: true,
      };
  
    case types.POST_PAIN_MGMT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isPosting: false,
      };
  
    case types.POST_PAIN_MGMT_FAILURE:
      return {
        ...state,
        result: [],
        isPosting: false,
      };

  default:
    return state;
  }
};

export default authPMTProvReducer;
